import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-shrink-0 mr-3"
}
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "mt-2 pt-2 border-t border-gray-100 text-xs text-gray-500"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "list-disc pl-4" }
const _hoisted_7 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_8 = { class: "text-xs text-gray-400 mt-1 px-1" }
const _hoisted_9 = {
  key: 1,
  class: "flex-shrink-0 ml-3"
}
const _hoisted_10 = { class: "h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden" }
const _hoisted_11 = {
  key: 0,
  class: "text-sm font-semibold text-gray-600"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-container", { 'user-message': _ctx.isUser, 'bot-message': !_ctx.isUser }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-start", { 'justify-end': _ctx.isUser }])
    }, [
      (!_ctx.isUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center overflow-hidden" }, [
              _createElementVNode("svg", {
                class: "h-5 w-5 text-blue-600",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                })
              ])
            ], -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["message-content", { 'items-end': _ctx.isUser }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["message-bubble max-w-[75%]", [
          _ctx.isUser ? 'bg-blue-700 text-white' : 'bg-white border border-gray-200',
          _ctx.isUser ? 'rounded-tl-lg rounded-bl-lg rounded-tr-lg' : 'rounded-tr-lg rounded-br-lg rounded-tl-lg',
          _ctx.isUser ? 'ml-auto' : ''
        ]])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["text-sm min-width-1 ai-content", { 'text-gray-800': !_ctx.isUser }]),
              innerHTML: _ctx.message.content
            }, null, 10, _hoisted_3),
            (_ctx.message.metadata && !_ctx.isUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.message.metadata.sources && _ctx.message.metadata.sources.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "font-medium mb-1" }, "Sources:", -1)),
                        _createElementVNode("ul", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.metadata.sources, (source, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(source), 1))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.message.metadata.confidence)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Confidence: " + _toDisplayString((_ctx.message.metadata.confidence * 100).toFixed(1)) + "% ", 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formattedTime), 1)
      ], 2),
      (_ctx.isUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.userAvatar)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.userInitials), 1))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.userAvatar,
                    alt: "User avatar",
                    class: "h-full w-full object-cover"
                  }, null, 8, _hoisted_12))
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}